import find from 'lodash/find';

export default (timesheet, rowIndex = -1) =>
  !!find(
    timesheet.rows,
    (row, i) => i !== rowIndex && !row.Operation && !row.IndirectCode
  );
